import { GetterTree } from 'vuex';
import { EmpathizeState } from '../../models';
import { RootStoreState } from '../store.interfaces';
import { EmpathizeDetectedStateGetter } from './getters/empathize-detected-state.getter';
import { HighlightedEmpathizeItemGetter } from './getters/highlighted-empathize-item.getter';
import { LayoutGetter } from './getters/layout.getter';
import { NextQueriesSuggestionsGetter } from './getters/next-queries-suggestions.getter';
import { RedirectionsSuggestionsGetter } from './getters/redirections-suggestions.getter';
import { ResultsSuggestionsGetter } from './getters/results-suggestions.getter';
import { ShowEmpathizeOpenGetter } from './getters/show-empathize-open.getter';
import { SuggestionsGetter } from './getters/suggestions.getter';

export const EMPATHIZE_GETTERS: GetterTree<EmpathizeState, RootStoreState> = {
  ...new HighlightedEmpathizeItemGetter().getters,
  ...new EmpathizeDetectedStateGetter().getters,
  ...new LayoutGetter().getters,
  ...new NextQueriesSuggestionsGetter().getters,
  ...new RedirectionsSuggestionsGetter().getters,
  ...new ResultsSuggestionsGetter().getters,
  ...new ShowEmpathizeOpenGetter().getters,
  ...new SuggestionsGetter().getters
};
